import React from "react";
import MarketingLayout from "@/components/marketing/MarketingLayout";
import Hero from "@/components/marketing/Hero";
import Coverage from "@/components/marketing/Coverage";
import ValuePillars from "@/components/marketing/ValuePillars";
import Manifesto from "@/components/marketing/Manifesto";
import ServicesGrid from "@/components/marketing/ServicesGrid";
import IndustriesPanels from "@/components/marketing/IndustriesPanels";
import { NewLocation, Process } from "@/components/marketing/NewLocation";
import EditorialMarquee from "@/components/marketing/EditorialMarquee";
import SupportPlansSection from "@/components/marketing/SupportPlansSection";
import { ProjectsSection, FaqSection, ReferralPartner, FinalCTA } from "@/components/marketing/Sections";
import SEO from "@/components/SEO";

export default function Home() {
    return (
        <MarketingLayout>
            <SEO
                title="Final Cut Technologies · Commercial Technology in Metro Vancouver"
                description="Commercial AV, business Wi-Fi, digital signage, POS coordination and cable management for restaurants, hotels, clinics, retail and offices across Metro Vancouver."
            />
            <Hero />
            <Coverage />
            <ValuePillars />
            <Manifesto />
            <EditorialMarquee />
            <ServicesGrid limit={6} />
            <IndustriesPanels />
            <NewLocation />
            <Process />
            <SupportPlansSection />
            <ProjectsSection />
            <ReferralPartner />
            <FaqSection items={undefined} />
            <FinalCTA />
        </MarketingLayout>
    );
}
